<div
  [class]="'page-content-field ' + field"
  *ngIf="pageModel && fieldValue"
  [innerHtml]="fieldValue"
></div>
